import React, { Component, ErrorInfo } from "react";

import ErrorPage from "./ErrorPage";
// import { Grid } from "@mui/material";
// import "./errorpage.scss"
// import ErrorPage from "./ErrorPage";

// import Dialog from "@mui/material/Dialog";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught an error: ", error, errorInfo);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage title={"Something went wrong!"} errortext={"Oops! Please refresh the page and try again"} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
